export const auditLog = {
  history: 'Istoric',
  filters: 'Filtre',
  noChanges: 'Nu există schimbări',
  error: 'Încărcarea istoricului a eșuat',
  retry: 'Reîncearcă',
  changedLabel: 'a schimbat',
  addedLabel: 'a adăugat',
  removedLabel: 'a eliminat',
  unknownUser: 'Un utilizator',
  none: 'nimic',
  allUsers: 'Toți utilizatorii',
  allProperties: 'Toate proprietățile',
  dateFrom: 'De la data',
  dateTo: 'Până la data',

  toasts: {
    errorGetAuditLogTitle: 'Istoric',
    errorGetAuditLogMessage: 'Încărcarea istoricului a eșuat'
  },

  btn: {
    showHistory: 'Vezi istoric',
    hideHistory: 'Ascunde istoricul'
  }
}
